import { configureStore } from '@reduxjs/toolkit'
import SBRMReducer from './SBRMReducer'
import ProfileReducer from './ProfileReducer'
import UserReducer from './UserReducer'
import AutomationReducer from './AutomationReducer'
import AnswerReducer from './AnswerReducer'
import ContactReducer from './ContactReducer'
import AnalyticsEventReducer from './AnalyticsEventReducer'

export const store = configureStore({
  reducer: {
    SBRM: SBRMReducer,
    profile: ProfileReducer,
    automation: AutomationReducer,
    answer: AnswerReducer,
    contact: ContactReducer,
    analyticsEvent: AnalyticsEventReducer,

    user: UserReducer,
  },
  devTools: process.env.REACT_APP_ENVIRONMENT !== 'production',
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
